import { render, staticRenderFns } from "./PartnerProductList.vue?vue&type=template&id=596687cf&scoped=true"
import script from "./PartnerProductList.vue?vue&type=script&lang=js"
export * from "./PartnerProductList.vue?vue&type=script&lang=js"
import style0 from "./PartnerProductList.vue?vue&type=style&index=0&id=596687cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596687cf",
  null
  
)

export default component.exports